<template>
  <div
    v-if="showCallout"
    :class="`flex relative items-start m-0 mb-2 py-1 px-2 pdl-callout pdl-callout--${kind} ${calloutClasses}`"
    :role="role"
  >
    <pdl-icon :name="displayIcon" />
    <div class="flex-1 text-md text-gray-100">
      <!-- @slot Slot for primarily text content. -->
      <slot name="content"></slot>
    </div>
    <pdl-button v-if="isDismissible" text icon-only icon="close" label="Dismiss" @click="dismiss" />
  </div>
</template>

<script>
import {PdlButton} from '@pedal/pdl-button';
import {PdlIcon} from '@pedal/pdl-icon';

const calloutClassesMap = {
  default: 'bg-primary-3 border border-primary-6 text-primary-9',
  success: 'bg-success-3 border border-success-6 text-success-9',
  warning: 'bg-warning-3 border border-warning-6 text-warning-9',
  error: 'bg-alert-3 border border-alert-6 text-alert-9',
};

export default {
  name: 'PdlCallout',
  components: {PdlButton, PdlIcon},
  props: {
    /**
     * Sets the visual of the callout.
     */
    kind: {
      type: String,
      default: 'default',
      validator: (value) => ['default', 'success', 'warning', 'error'].includes(value),
    },
    /**
     * Sets the dismissible value of a callout.
     */
    isDismissible: {
      type: Boolean,
      default: false,
    },
    /**
     * Sets the icon for the default callout kind to the string provided.
     */
    icon: {
      type: String,
      default: null,
    },
    /**
     * Set the appropriate ARIA live region role to communicate information to a user.
     */
    role: {
      type: String,
      default: 'status',
      validator: function (value) {
        return ['status', 'alert', 'log'].includes(value);
      },
    },
  },
  data() {
    return {
      showCallout: true,
    };
  },
  computed: {
    calloutClasses() {
      return calloutClassesMap[this.kind];
    },
    displayIcon() {
      switch (this.kind) {
        case 'success':
          return 'check_circle';
        case 'warning':
          return 'warning';
        case 'error':
          return 'error';
        default:
          return this.icon ? this.icon : 'info';
      }
    },
  },
  methods: {
    dismiss() {
      /**
       * Emitted when the dismiss icon is clicked.
       */
      this.$emit('dismiss');
      this.showCallout = false;
    },
  },
};
</script>

<style lang="scss">
@import 'Callout.scss';
</style>
